/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiHealthCheckDto } from '../../models/api-health-check-dto';

export interface AppControllerApiHealthCheck$Params {
}

export function appControllerApiHealthCheck(http: HttpClient, rootUrl: string, params?: AppControllerApiHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiHealthCheckDto>> {
  const rb = new RequestBuilder(rootUrl, appControllerApiHealthCheck.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiHealthCheckDto>;
    })
  );
}

appControllerApiHealthCheck.PATH = '/api/api/health-check';
